function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22419",
    transform: "translate(-.11)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(.11)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17707",
    d: "M13.889 22.292h-1.445v-5.777H11M12.444 12h.014",
    transform: "translate(.037 -5.65)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
};

export default SvgInformation;